import React from 'react';
import UsersPage from './UsersPage';
import Backend from '../../../Layouts/Backend';
import Loading from '../../../Helpers/Loading';
import { connect } from 'react-redux';
import { configureActions } from '../../../../actions/configure.action';
import helper from '../../../../utils/helper';
import usersActions from '../../../../actions/users.actions';
import { bindActionCreators } from 'redux';
import { isEqual } from 'lodash';

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loading: false,
      errors: '',
      openModal: 0,
      inactiveShouldHide: localStorage.getItem('inactiveShouldHide') === 'true',
      lockedShouldHide: localStorage.getItem('lockedShouldHide') === 'true',
      selectedUser: {},
      ctxMenuOptions: [
        [
          {
            name: 'Edit user',
            action: (row, rowIndex) => {
              this.props.history.push(`/configure/users/edit-user/${row.id}`);
            },
          },
          helper.checkPermission('API.Users.ExpirePassword') && {
            name: 'Expire password',
            action: (row, rowIndex) => {
              this.setState({ openModal: 1, selectedUser: row });
            },
          },
          helper.checkPermission('API.Users.LockUser') && {
            name: 'Lock user',
            action: (row, rowIndex) => {
              this.setState({ openModal: 2, selectedUser: row });
            },
          },
          helper.checkPermission('API.Users.UnlockUser') && {
            name: 'Unlock user',
            action: (row, rowIndex) => {
              this.setState({ openModal: 3, selectedUser: row });
            },
          },
          helper.checkPermission('API.Users.ActiveUser') && {
            name: 'Mark active',
            action: (row, rowIndex) => {
              this.setState({ openModal: 4, selectedUser: row });
            },
          },
          helper.checkPermission('API.Users.InactiveUser') && {
            name: 'Mark inactive',
            action: (row, rowIndex) => {
              this.setState({ openModal: 5, selectedUser: row });
            },
          },
          {
            name: 'Reset password',
            action: (row, rowIndex) => {
              this.props.history.push(
                `/configure/users/reset-password/${row.id}`,
              );
            },
          },
        ],
      ],
    };
    this.isRequireConfirmation = helper.isRequireConfirmation();
    this.columns = [
      {
        dataField: 'departmentName',
        text: 'Department',
        sort: true,
        onSort: this.onSort,
      },
      { dataField: 'name', text: 'First Name', sort: true },
      { dataField: 'surname', text: 'Last Name', sort: true },
      { dataField: 'title', text: 'Title', sort: true },
      { dataField: 'userName', text: 'Username', sort: true },
      {
        dataField: 'passwordExpirationDate',
        text: 'Password Expiration',
        sort: true,
        isDateTime: true,
        headerStyle: { width: 170 },
      },
      {
        dataField: 'roleNames',
        text: 'Roles',
        sort: true,
        formatter: (cell) => cell.join(', '),
        filterValue: (cell) => cell.join(', '),
        sortValue: (cell) => cell.join(', '),
      },
      {
        dataField: 'active',
        text: 'Active',
        sort: true,
        headerStyle: { width: 70, textAlign: 'center' },
        formatter: (cell) => (
          <div className="d-flex justify-content-center align-items-center">
            <img
              src={
                process.env.PUBLIC_URL +
                `./img/statusIcon/${cell ? 'OK.png' : 'Disabled.png'}`
              }
              width={24}
              height={24}
              alt="active-icon"
            />
          </div>
        ),
        filterValue: (cell) => (cell ? 'OK' : 'Disabled'),
        style: {
          padding: 0,
          verticalAlign: 'middle',
        },
        sortValue: (cell) => (cell ? 'Active' : 'Inactive'),
      },
      {
        dataField: 'lockStatus',
        text: 'Lock Status',
        sort: true,
        headerStyle: { width: 105, textAlign: 'center' },
        align: 'center',
        formatter: (cell) =>
          cell ? (
            <div className="d-flex justify-content-center align-items-center">
              <i
                className="md-icon"
                style={{ fontSize: 24, width: 24, height: 24 }}
              >
                lock
              </i>
            </div>
          ) : null,
        style: {
          padding: 0,
          verticalAlign: 'middle',
        },
        sortValue: (cell) => (cell ? 'Lock' : 'NoLock'),
      },
      {
        dataField: 'createdDate',
        text: 'Created Date',
        sort: true,
        isDateTime: true,
        // headerStyle: { width: 170 },
      },
    ];
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.users !== prevState.users) {
      state.users = nextProps.configure.users;
    }
    // if (nextProps.configure.loading !== prevState.loading) {
    //   state.loading = nextProps.configure.loading;
    // }
    state.errors = helper.centralizeError([nextProps.configure.errors]);
    return Object.keys(state).length ? state : null;
  }

  onSort = (field, order) => {
    // console.log(field, order);
  };

  componentDidMount() {
    this.setState({ loading: true }, () =>
      this.props.configureActions
        .getUsers()
        .finally(() => this.setState({ loading: false })),
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      Object.keys(this.state.selectedUser).length &&
      !isEqual(prevState.selectedUser, this.state.selectedUser)
    ) {
      const ctxMenuOptions = [
        [
          {
            name: 'Edit user',
            action: (row, rowIndex) => {
              this.props.history.push(`/configure/users/edit-user/${row.id}`);
            },
          },
          helper.checkPermission('API.Users.ExpirePassword') && {
            name: 'Expire password',
            action: (row, rowIndex) => {
              this.setState({ openModal: 1, selectedUser: row });
            },
          },
          helper.checkPermission('API.Users.LockUser') &&
            this.state.selectedUser.lockStatus === false && {
              name: 'Lock user',
              action: (row, rowIndex) => {
                this.setState({ openModal: 2, selectedUser: row });
              },
            },
          helper.checkPermission('API.Users.UnlockUser') &&
            this.state.selectedUser.lockStatus === true && {
              name: 'Unlock user',
              action: (row, rowIndex) => {
                this.setState({ openModal: 3, selectedUser: row });
              },
            },
          helper.checkPermission('API.Users.ActiveUser') &&
            this.state.selectedUser.active === false && {
              name: 'Mark active',
              action: (row, rowIndex) => {
                this.setState({ openModal: 4, selectedUser: row });
              },
            },
          helper.checkPermission('API.Users.InactiveUser') &&
            this.state.selectedUser.active === true && {
              name: 'Mark inactive',
              action: (row, rowIndex) => {
                this.setState({ openModal: 5, selectedUser: row });
              },
            },
          {
            name: 'Reset password',
            action: (row, rowIndex) => {
              this.props.history.push(
                `/configure/users/reset-password/${row.id}`,
              );
            },
          },
        ].filter((ctx) => typeof ctx !== 'boolean'),
      ];
      this.setState({ ctxMenuOptions });
    }
  }

  async doAction() {
    switch (this.state.openModal) {
      case 2:
        return await this.props.usersActions.lockUser(
          this.state.selectedUser.id,
        );
      case 3:
        return await this.props.usersActions.unlockUser(
          this.state.selectedUser.id,
        );
      case 4:
        return await this.props.usersActions.activeUser(
          this.state.selectedUser.id,
        );
      case 5:
        return await this.props.usersActions.inactiveUser(
          this.state.selectedUser.id,
        );
      default:
        return await this.props.usersActions.expirePassword(
          this.state.selectedUser.id,
        );
    }
  }

  onYes = () => {
    this.setState(
      { errors: '' },
      async () =>
        await this.doAction()
          .then(() => this.setState({ openModal: 0, selectedUser: {} }))
          .then(async () => await this.props.configureActions.getUsers())
          .catch((errors) => this.setState({ errors, openModal: 0 })),
    );
  };

  onCancel = () => {
    this.setState({ openModal: 0, selectedUser: {} });
  };

  hideInactive = (e) => {
    this.setState({ inactiveShouldHide: e.target.checked }, () => {
      localStorage.setItem('inactiveShouldHide', e.target.checked);
    });
  };

  hideLocked = (e) => {
    this.setState({ lockedShouldHide: e.target.checked }, () => {
      localStorage.setItem('lockedShouldHide', e.target.checked);
    });
  };

  render() {
    if (this.state.loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return (
      <UsersPage
        {...this.state}
        datagridProps={{
          columns: this.columns,
        }}
        ctxMenuOptions={this.state.ctxMenuOptions}
        onYes={this.onYes}
        onCancel={this.onCancel}
        onContext={(row) => this.setState({ selectedUser: row })}
        hideInactive={this.hideInactive}
        hideLocked={this.hideLocked}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    usersActions: bindActionCreators(Object.assign({}, usersActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);
